<template>
    <div class="container">
        <form @submit.prevent="signup()" class="form-signup">
            <input v-model="firstname" type="text" class="form-control" :placeholder="$t('firstnamePlaceholder')" required autofocus/>
            <input v-model="lastname" type="text" class="form-control" :placeholder="$t('lastnamePlaceholder')" style="margin-top: 10px" required/>
            <input v-model="email" type="email" class="form-control" :placeholder="$t('emailPlaceholder')" style="margin-top: 10px" required/>
            <input v-model="password" type="password" class="form-control" :placeholder="$t('passwordPlaceholder')" style="margin-top: 10px" required/>
            <!--<input v-model="confirmedPass" type="password" id="inputConfirmPassword" class="form-control" placeholder="Confirm your password" required/> -->
            <button class="btn btn-lg btn-primary btn-block" type="submit">{{ $t('signupButton') }}</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'signup',
    data() {
        return {
            firstname: null,
            lastname: null,
            email: null,
            password: null,
            confirmedPass: null // Simdilik yok
        };
    },
    methods: {
        signup() {
            return this.axios
                .post('/signup', {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    password: this.password
                })
                .then(() => {
                    this.$router.push('dashboard');
                    return true;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.form-signup {
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
    .form-signup-heading {
        float: left;
        font-size: 30px;
    }
    .form-control {
        position: relative;
        height: auto;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px;
        font-size: 16px;

        &:focus {
            z-index: 2;
        }
    }

    input[type='email'] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    input[type='password'] {
        margin-bottom: -1px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    input[type='text'] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    input[id='inputConfirmPassword'] {
        margin-bottom: 10px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
}
</style>

<i18n>
    {
        "tr": {
            "firstnamePlaceholder": "Adınızı girin",
            "lastnamePlaceholder" : "Soyadınızı girin",
            "emailPlaceholder" : "Email adresinizi girin",
            "passwordPlaceholder" : "Şifrenizi girin",
            "signupButton" : "Üye Ol"
        },
        "en": {
            "firstnamePlaceholder": "Enter your firstname",
            "lastnamePlaceholder" : "Enter your lastname",
            "emailPlaceholder" : "Enter your email",
            "passwordPlaceholder" : "Enter your password",
            "signupButton" : "Sign Up"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Signup.vue